/**
 * BackButton Component
 * Consistent back button with optional label
 */

import React from 'react';
import { ArrowLeft } from 'lucide-react';
import styles from './BackButton.module.css';

export interface BackButtonProps {
  /** Click handler */
  onClick: () => void;
  /** Optional label text next to icon */
  label?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({ onClick, label }) => {
  return (
    <button
      type="button"
      className={styles.backButton}
      onClick={onClick}
      aria-label={label || 'Go back'}
    >
      <ArrowLeft size={20} />
      {label && <span className={styles.label}>{label}</span>}
    </button>
  );
};

export default BackButton;
